module.exports = __webpack_public_path__ + "img/help.933ba2ac.svg";